module.exports = __webpack_public_path__ + "img/plus.41a949c0.png";